module.exports = __webpack_public_path__ + "4ebe1a9.webp";